import { ProviderName } from '../../../../Quotes/types/store';

export const cloudProviderForDisplay = (provider: ProviderName) => {
  switch (provider) {
    case ProviderName.AWS:
      return 'Amazon Web Services';
    case ProviderName.Azure:
      return 'Microsoft Azure';
    case ProviderName.Alibaba:
      return 'Alibaba Cloud';
    case ProviderName.Google:
      return 'Google Cloud Platform';
    case ProviderName.IBM:
      return 'IBM Cloud';
    case ProviderName.Oracle:
      return 'Oracle Cloud';
    case ProviderName.Office365:
      return 'Office 365';
    case ProviderName.Salesforce:
      return 'Salesforce';
    case ProviderName.Equinix:
      return 'Equinix';
    case ProviderName.SSEET:
      return 'Neos';
    case ProviderName.Other:
      return 'Other Cloud Services';
    case ProviderName.NOT_DEFINED:
      return 'Not Defined';
    default:
      return 'Unknown Provider';
  }
};
